import { TranslationCodePipe, TranslatePipe, PublicUrlPipe, FractionCupPipe } from '@app/shared/pipes';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  declarations: [TranslatePipe, TranslationCodePipe, PublicUrlPipe, FractionCupPipe],
  exports: [TranslatePipe, TranslationCodePipe, PublicUrlPipe, FractionCupPipe],
})
export class SharedPipesModule {}
